import { render } from "./EditMailtoLink.vue?vue&type=template&id=063ed535&scoped=true"
import script from "./EditMailtoLink.vue?vue&type=script&lang=js"
export * from "./EditMailtoLink.vue?vue&type=script&lang=js"

import "./EditMailtoLink.vue?vue&type=style&index=0&id=063ed535&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063ed535"],['__file',"src/scripts/common/sideBars/pages/EditMailtoLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "063ed535"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('063ed535', __exports__)) {
    api.reload('063ed535', __exports__)
  }
  
  module.hot.accept("./EditMailtoLink.vue?vue&type=template&id=063ed535&scoped=true", () => {
    api.rerender('063ed535', render)
  })

}


export default __exports__